const CHANGE_TYPE = 'CHANGE_TYPE'
const CHANGE_SEARCH = 'CHANGE_SEARCH'

const state = {
    type: "",
    search: "",
}

const actions = {
    changeType({ commit }, value) {
        commit(CHANGE_TYPE, value)
    },
    changeSearch({ commit }, value) {
        commit(CHANGE_SEARCH, value)
    },
}

const mutations = {
    [CHANGE_TYPE](state, value) {
        state.type = value
    },
    [CHANGE_SEARCH](state, value) {
        state.search = value
    },
}

export default {
    state,
    actions,
    mutations
}